import { CURRENT_CONFIG as LOCAL_CONFIG } from './config.local'
import { CURRENT_CONFIG as TEST_CONFIG } from './config.test'
import { CURRENT_CONFIG as PRD_CONFIG } from './config.prd'

const MODE = import.meta.env.MODE || 'production'

// 根据运行模式选择配置：
// gclocal -> 国创环境
// test  -> 测试环境
// 其它   -> 生产环境
let CONFIG

switch (MODE) {
  case 'gclocal':
    CONFIG = LOCAL_CONFIG
    break
  case 'test':
    CONFIG = TEST_CONFIG
    break
  default:
    CONFIG = PRD_CONFIG
    break
}

export const CURRENT_CONFIG = CONFIG
